import React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import CommonButton from '../../../../components/common-button/CommonButton';
import {
  changeNiumForexScreen,
  setCrossSellingInformationAction
} from '../../../../redux/actions/nium-forex/nium-forex-action';
import { AppDispatch } from '../../../../store.type';
import { NF_SCREENS } from '../../root/screenConstants';
import { CrossSellingSuccessContainer } from './styles';
import { logUserEventForNFCrossSelling } from './utils';
import { niumForexCrossSellingSelector } from '../../../../redux/selectors';
import { reset } from 'redux-form';
import { NIUM_FOREX_CROSS_SELL_FORM_NAME } from './utils/constants';
import { EventNames } from '../../../../utils/events/eventsConstants';

const NFCrossSellingSuccess = (): React.ReactElement => {
  const dispatch = useDispatch<AppDispatch>();
  const {
    components: {
      nf_cross_sell_success_view: { title, description, buttonText, icon }
    }
  } = useSelector(niumForexCrossSellingSelector);
  const handleClick = () => {
    logUserEventForNFCrossSelling({
      eventName: EventNames.NF_CROSS_SELLING.goHome,
      pageName: NF_SCREENS.cross_selling_success
    });
    // reset previous values
    dispatch(
      setCrossSellingInformationAction({
        currentExploreTab: 'prepaid_forex_card',
        selectedProducts: []
      })
    );
    dispatch(reset(NIUM_FOREX_CROSS_SELL_FORM_NAME));
    dispatch(changeNiumForexScreen(NF_SCREENS.send_money));
  };
  return (
    <CrossSellingSuccessContainer>
      <div className="container">
        <img className="success-icon" src={icon} alt="form submit success" />
        <span className="__header">{title}</span>
        <span className="__sub-header">{description}</span>
        <CommonButton
          width={410}
          text={buttonText}
          margin="0 0 24px 0"
          height={50}
          onClick={handleClick}
        />
      </div>
    </CrossSellingSuccessContainer>
  );
};

export default NFCrossSellingSuccess;
